/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getSvgContactBySvgId } from '../fn/svg-contact-controller/get-svg-contact-by-svg-id';
import { GetSvgContactBySvgId$Params } from '../fn/svg-contact-controller/get-svg-contact-by-svg-id';
import { SvgContact } from '../models/svg-contact';

@Injectable({ providedIn: 'root' })
export class SvgContactControllerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getSvgContactBySvgId()` */
  static readonly GetSvgContactBySvgIdPath = '/svgcontact/{svgId}';

  /**
   * selecting the contact information of responsible svg
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSvgContactBySvgId()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSvgContactBySvgId$Response(params: GetSvgContactBySvgId$Params, context?: HttpContext): Observable<StrictHttpResponse<SvgContact>> {
    return getSvgContactBySvgId(this.http, this.rootUrl, params, context);
  }

  /**
   * selecting the contact information of responsible svg
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSvgContactBySvgId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSvgContactBySvgId(params: GetSvgContactBySvgId$Params, context?: HttpContext): Observable<SvgContact> {
    return this.getSvgContactBySvgId$Response(params, context).pipe(
      map((r: StrictHttpResponse<SvgContact>): SvgContact => r.body)
    );
  }

}
